/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are meetings often scheduled for 30 minutes?`)
};

const es_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué las reuniones suelen programarse para 30 minutos?`)
};

const de_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sind Meetings oft auf 30 Minuten angesetzt?`)
};

const nl_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom worden vergaderingen vaak ingepland voor 30 minuten?`)
};

const fr_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les réunions durent-elles souvent 30 minutes ?`)
};

const it_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché le riunioni sono spesso programmate per 30 minuti?`)
};

const pt_br2_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que as reuniões costumam ser agendadas para 30 minutos?`)
};

const pt_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que as reuniões são muitas vezes marcadas para 30 minutos?`)
};

const ja_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜミーティングはよく30分に設定されるのですか？`)
};

const zh_timer_u30m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么会议通常安排为30分钟？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u30m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u30m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u30m_faq4_q", locale)
	if (locale === "en") return en_timer_u30m_faq4_q(inputs)
	if (locale === "es") return es_timer_u30m_faq4_q(inputs)
	if (locale === "de") return de_timer_u30m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u30m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u30m_faq4_q(inputs)
	if (locale === "it") return it_timer_u30m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u30m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u30m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u30m_faq4_q(inputs)
	return zh_timer_u30m_faq4_q(inputs)
};